import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ElementCondition, ElementConditionViewData } from 'icreate/common/models/element-condition';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ElementConditionService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getByElementId(elementId: string) {
        return await lastValueFrom(
            this.http.get<ElementConditionViewData[]>(`${this.domain}/api/elementCondition`, {
                headers: this.headers,
                params: { elementId },
            })
        );
    }

    async create(elementConditionData: ElementCondition[]) {
        return await lastValueFrom(
            this.http.post<ElementConditionViewData[]>(`${this.domain}/api/elementCondition`, elementConditionData, {
                headers: this.headers,
            })
        );
    }

    async update(elementConditionData: ElementCondition[], elementId: string) {
        return await lastValueFrom(
            this.http.put<ElementConditionViewData[]>(`${this.domain}/api/elementCondition`, elementConditionData, {
                headers: this.headers,
                params: { elementId },
            })
        );
    }

    async deleteByElementId(elementId: string) {
        return await lastValueFrom(
            this.http.delete(`${this.domain}/api/elementCondition`, {
                headers: this.headers,
                params: { elementId },
            })
        );
    }
}
